<template>
  <section v-if="isShow" class="catalog-fixed-controls">
    <div class="catalog-fixed-controls__container">
      <CatalogFilterButton @click="openFilter(true)">
        {{ result.messages.title }}
      </CatalogFilterButton>
      <CatalogSort v-if="screenWidth >= 992" :result="catalogSort" @changeSort="changePageData" />
      <div class="catalog-fixed-panel">
        <SearchEngineTop />
        <Entry />
        <SmallFavourite />
        <SmallBasket />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import CatalogFilterButton from '@components/Catalog/CatalogFilterButton.vue';
import CatalogSort from '@components/Catalog/CatalogSort/CatalogSort.vue';
import useScreenWidth from '@use/useScreenWidth';
import SmallBasket from '@components/Basket/SmallBasket.vue';
import SearchEngineTop from '@components/Search/SearchEngineTop/SearchEngineTop.vue';
import SmallFavourite from '@components/favourite/SmallFavourite.vue';
import Entry from '@components/Cabinet/Entry/Entry.vue';

export default {
  name: 'CatalogFixedControls',
  components: {
    Entry,
    SmallFavourite,
    SearchEngineTop,
    SmallBasket,
    CatalogSort,
    CatalogFilterButton,
  },
  props: ['result'],
  data() {
    return {
      isShow: false,
      screenWidth: useScreenWidth(),
    };
  },
  computed: {
    ...mapState({
      catalogSmartFilter: ({ catalog }) => catalog.data.catalogSmartFilter,
      catalogSort: ({ catalog }) => catalog.data.catalogSort,
    }),
    ...mapGetters({
      getSelectedFilters: 'catalog/getSelectedFilters',
    }),
  },
  methods: {
    ...mapMutations({
      openFilter: 'catalog/openFilter',
      deleteSelectedItem: 'catalog/deleteSelectedItem',
    }),
    ...mapActions({
      changePageData: 'catalog/changePageData',
      changeFilter: 'catalog/changeFilter',
    }),
    async handlerRemove(item) {
      this.deleteSelectedItem(item);
      setTimeout(this.changeFilter, 4);
    },
    handlerScroll() {
      this.scrollPosition = window.scrollY;
      const offsetTop = document.querySelector('.catalog-controls')?.offsetTop;
      if (offsetTop - window.scrollY > 0 && this.isShow) {
        this.isShow = false;
      } else if (offsetTop - window.scrollY <= 0 && !this.isShow) {
        this.isShow = true;
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handlerScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handlerScroll);
  },
};
</script>

<style lang="scss" scoped>
.catalog-fixed-controls {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-bottom: 1px solid var(--background-grey);
  z-index: 3;
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
    @extend %container;
    @include point-md {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
  :deep(.catalog-filter-button) {
    @include point-md {
      padding: 8px 14px;
    }
    @include point-lg {
      padding: 12px 18px;
    }
  }
}
.catalog-fixed-panel {
  display: flex;
  align-items: center;
  gap: 24px;
  @include point-lg {
    gap: 28px;
  }
}
</style>
